import { Alert, Button, CircularProgress, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { Eye, EyeOff } from 'react-feather';
import { useAuth } from '../../authentication/useAuth';
import AuthShell from './AuthShell';

const Login = () => {
    const { login } = useAuth();
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    const handleLogin = async (event) => {
        event.preventDefault();
        if (busy) return;
        setError(null);
        setBusy(true);
        try {
            await login({ userName, password });
        } catch (error) {
            setError(error.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <AuthShell>
            <Stack component="form" onSubmit={handleLogin} spacing={2.5} noValidate>
                <div>
                    <Typography component="h2" sx={{ fontSize: 32, fontWeight: 600, lineHeight: 1.2 }}>Sign in</Typography>
                    <Typography color="text.secondary" sx={{ mt: 1 }}>Use the username and password your administrator gave you.</Typography>
                </div>
                <TextField label="Username" value={userName} onChange={(e) => setUserName(e.target.value)} autoComplete="username" autoFocus fullWidth />
                <TextField
                    label="Password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    fullWidth
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton aria-label={showPassword ? 'Hide password' : 'Show password'} onClick={() => setShowPassword((v) => !v)} edge="end">
                                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                {error && <Alert severity="error">{error}</Alert>}
                <Button type="submit" variant="contained" size="large" disabled={busy || !userName || !password}
                    startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null} sx={{ py: 1.25 }}>
                    Sign in
                </Button>
            </Stack>
        </AuthShell>
    )
}

export default Login
